import { useEffect, useRef, useState } from "react";

import { ChartIcon, EditIcon, Spinner } from "../../shared/svgIcon";
import { Dialog, DialogContent } from "../ui/dialog";
import { useForm } from "react-hook-form";
import { updateVitals } from "../../lib/api";
import { cn } from "../../shared/utils";
import { useStore } from "../../store";

const VitalCard = (props) => {
  const { vital, index, showDetailTab, onEdit } = props;
  // console.log(vital,'vitalcard')
  const vitalSession = useStore((state) => state.selectedVitals);
  const setVital = useStore((state) => state.setCurrentVitals);
  const [rangeWidth, setRangeWidth] = useState(0);
  const [startWidth, setStartWidth] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [scheduleLoader, setLoader] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const item = {};
      item[vital.name] = {
        value: parseInt(data[vital.name]),
        unit: vital.unit,
      };
      const payload = { data: item };
      console.log(data, "editData", payload);
      setLoader(true);
      const res = await updateVitals(vitalSession?.id, payload);
      if (res?.isSuccess) {
        setVital(res?.data?.result?.vitals);
        onEdit(res?.data?.result?.vitals?.data);
      }
      setLoader(false);
      closeModal();
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const openModal = () => {
    console.log("openModal");
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const containerRef = useRef(null);
  const background_gradient = [
    "linear-gradient(180deg,rgba(255,232.69,252.77,0.5) 0%,rgba(255,214.62,250.96,0.5) 100%)",
    "linear-gradient(180deg,rgba(228.28,249.69,227.84,0.5) 0%,rgba(211.42,253.94,210.56,0.5) 100%)",
    "linear-gradient(180deg,rgb(245.44,248.11,255) 0%,rgb(210.56,222.7,253.94) 100%)",
    "linear-gradient(180deg,rgb(249.69,248.81,227.84) 0%,rgb(248.63,245.52,170.93) 100%)",
    "linear-gradient(180deg,rgba(255,235.96,225.25,0.5) 0%,rgba(255,215.56,193.37,0.5) 100%)",
    "linear-gradient(180deg,rgba(238,255,251.94,0.5) 0%,rgba(183.28,239.06,232.37,0.5) 100%)",
  ];
  const getBackground = (index) => {
    return background_gradient[index % background_gradient.length];
  };

  useEffect(() => {
    const calculateWidths = () => {
      if (containerRef.current) {
        const divWidth = containerRef.current.clientWidth;
        const normalRangeWidth = divWidth * 0.6;
        const normalStart =
          vital?.normal_range?.lower_limit - vital?.allowed_range?.lower_limit;
        const normalEnd =
          vital?.allowed_range?.upper_limit - vital?.normal_range?.upper_limit;

        setContainerWidth(divWidth);
        if (normalStart == 0) {
          setStartWidth(0);
        } else if (normalEnd == 0) {
          setStartWidth(divWidth - normalRangeWidth);
        } else {
          setStartWidth(
            (normalStart / (normalEnd + normalStart)) * normalRangeWidth
          );
        }
        setRangeWidth(normalRangeWidth);
      }
    };

    calculateWidths();

    window.addEventListener("resize", calculateWidths);

    return () => {
      window.removeEventListener("resize", calculateWidths);
    };
  }, [index]);

  const getNormalPos = () => {
    return {
      width: rangeWidth,
      left: startWidth,
    };
  };

  const getCurrentPos = (value) => {
    if (!vital?.is_range_applicable) {
      return {
        left: 0,
        color: "#4BB543",
      };
    }
    if (value < vital?.allowed_range?.lower_limit) {
      return {
        left: 0,
        color: "#B33A3A",
      };
    } else if (value > vital?.allowed_range?.upper_limit) {
      return {
        left: containerWidth,
        color: "#B33A3A",
      };
    }

    let left = 0;
    let color = "#B33A3A";

    if (
      value >= vital?.normal_range?.lower_limit &&
      value <= vital?.normal_range?.upper_limit
    ) {
      const posUnit =
        rangeWidth /
        (vital?.normal_range?.upper_limit - vital?.normal_range?.lower_limit);
      left = startWidth + (value - vital?.normal_range?.lower_limit) * posUnit;
      color = "#4BB543";
    } else if (value < vital?.normal_range?.lower_limit) {
      const posUnit =
        startWidth /
        (vital?.normal_range?.lower_limit - vital?.allowed_range?.lower_limit);
      left = (value - vital?.allowed_range?.lower_limit) * posUnit;
    } else if (value > vital?.normal_range?.upper_limit) {
      const posUnit =
        startWidth /
        (vital?.allowed_range?.upper_limit - vital?.normal_range?.upper_limit);
      left =
        startWidth +
        rangeWidth +
        (value - vital?.normal_range?.upper_limit) * posUnit;
    }

    return { left, color };
  };
  return (
    <div
      key={index}
      style={{
        // borderColor: e?.style?.border,
        background: getBackground(index),
      }}
      className={`flex flex-col rounded-[30px] px-4 pt-4 pb-2 gap-3 border border-solid overflow-hidden shadow-[0px_4px_8px_#0000000f,0px_0px_4px_#0000000a]`}
    >
      <div className="flex  justify-between">
        <div className="flex">
          <div className="relative w-9 h-9">
            <img
              src={vital?.icon_url}
              fill={true}
              alt={vital?.display_name}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
          </div>

          <div className="flex flex-col gap-1 px-3">
            <p className="font-semibold text-base">{vital?.display_name}</p>
            <div className="flex ">
              <p
                style={{
                  color: getCurrentPos(+vital?.value).color,
                }}
                className={` font-bold text-2xl `}
              >
                {vital?.value}
              </p>
              <span
                style={{
                  color: getCurrentPos(+vital?.value).color,
                }}
                className={`text-sm mt-2 `}
              >
                {vital?.unit}
              </span>
              {vital.is_range_applicable && (
                <>
                  {" "}
                  <div className="shrink-0 bg-gray-400 h-full w-[1px] mx-2"></div>
                  <p className="font-normal text-sm ">
                    <span className="text-[#141b34]">Normal Range:</span>
                    <span className={`text-[#141b34]`}>&nbsp;</span> <br />
                    <span className={`text-[#4BB543] font-medium`}>
                      {vital?.normal_range?.lower_limit} -{" "}
                      {vital?.normal_range?.upper_limit}
                    </span>
                    <span className={`text-[#4BB543]`}> {vital?.unit}</span>
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="flex gap-2 mt-[-43px]">
          <button
            className="border border-none"
            onClick={() => props.showDetailTab(vital)}
          >
            {" "}
            <ChartIcon className=" h-5 w-5" />
          </button>
          <button className="border border-none" onClick={openModal}>
            <EditIcon stroke="blue" className=" h-5 w-4" />
          </button>
        </div>
      </div>

      {vital?.is_range_applicable && (
        <div className=" flex">
          <div
            ref={containerRef}
            className="relative w-full h-2 bg-[#B33A3A] rounded-xl my-8"
          >
            <div
              style={{
                left: getCurrentPos(+vital?.value).left,
                color: getCurrentPos(+vital?.value).color,
              }}
              className="absolute tooltip"
            >
              <div
                style={{ backgroundColor: getCurrentPos(+vital?.value).color }}
                className="absolute z-10 bottom-3 left-1/2 transform -translate-x-[50%]  text-white text-xs px-2 py-1 rounded whitespace-nowrap "
              >
                {vital?.value}
              </div>
            </div>
            <span
              style={getNormalPos()}
              className="absolute h-2 bg-[#4BB543] z-10 rounded-xl"
            >
              <span className=" absolute left-0 -translate-x-1/2  mt-2">
                {vital?.normal_range?.lower_limit}
              </span>
              <span className="absolute right-0 translate-x-1/2 mt-2">
                {vital?.normal_range?.upper_limit}
              </span>
            </span>
          </div>
        </div>
      )}
      <Dialog open={modalOpen} onOpenChange={setModalOpen}>
        <DialogContent className="flex flex-col gap-2 sm:max-w-[340px] bg-white rounded-[34px] sm:rounded-[34px] border border-solid border-[#bcc1d1] pt-2 pb-6 px-4 shadow-[0px_4px_8px_#0000000f,0px_0px_4px_#0000000a]">
          <p className="text-center font-semibold text-base mt-4">
            Current {vital?.display_name}
          </p>
          <div className="flex justify-center items-center">
            <div className="relative w-8 h-8 ">
              <image
                src={vital?.icon_url}
                fill={true}
                alt={vital?.display_name}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 13vw"
              />
            </div>
            <p
              style={{ color: getCurrentPos(+vital?.value).color }}
              className="flex text-center font-semibold text-[36px]   ms-2"
            >
              {vital?.value}
            </p>
            <span
              style={{ color: getCurrentPos(+vital?.value).color }}
              className="font-regular text-[16px]  mt-3"
            >
              {vital?.unit}
            </span>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex justify-center gap-4 mt-2">
              <input
                {...register(vital?.name, {
                  required: true,
                })}
                id={vital?.name}
                name={vital?.name}
                type="number"
                step={vital?.type == "float" ? "0.01" : ""}
                autoComplete="off"
                autoCorrect="off"
                autoFocus={true}
                placeholder="Enter New Value"
                className="h-10 border border-[#bcc1d1] shadow-[0px_4px_8px_#0000000f,0px_0px_4px_#0000000a] text-center text-black rounded-[10px]"
                // className=" bg-gray-200  flex h-9 w-full rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
              />
              {errors[vital?.name] && (
                <p className="py-2 text-xs text-red-500">{"required"}</p>
              )}
              <button
                type="submit"
                className={cn(
                  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                  "bg-primary text-primary-foreground shadow hover:opacity-[.75]",
                  "h-9 px-4 py-2"
                )}
              >
                {scheduleLoader && (
                  <Spinner className="mr-2 h-4 w-4 animate-spin" />
                )}{" "}
                Save
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default VitalCard;
